import _styled from "@emotion/styled/base";
export var Cell = /*#__PURE__*/_styled("div", true ? {
  target: "e1nn4tqt0"
} : {
  target: "e1nn4tqt0",
  label: "Cell"
})("color:", function (_ref) {
  var color = _ref.color;
  return color;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.typography.textRegularSmall.css;
}, ";", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{", function (_ref4) {
  var theme = _ref4.theme;
  return theme.typography.pSmall.css;
}, ";}" + (true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvVGFibGVQcmljaW5nL0NlbGwvQ2VsbC52aWV3cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFReUMiLCJmaWxlIjoiL3dvcmtkaXIvbGlicy9tYXRjaGEvcmVjaXBlcy9UYWJsZVByaWNpbmcvQ2VsbC9DZWxsLnZpZXdzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmltcG9ydCB0eXBlIHsgVGhlbWVDb2xvcnMgfSBmcm9tICdAc2VnbWVudC9tYXRjaGEvZm91bmRhdGlvbnMvVGhlbWUnXG5cbmV4cG9ydCBpbnRlcmZhY2UgQ2VsbFByb3BzIHtcbiAgY29sb3I/OiBUaGVtZUNvbG9yc1xufVxuXG5leHBvcnQgY29uc3QgQ2VsbCA9IHN0eWxlZC5kaXY8Q2VsbFByb3BzPmBcbiAgY29sb3I6ICR7KHsgY29sb3IgfSkgPT4gY29sb3J9O1xuXG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUudHlwb2dyYXBoeS50ZXh0UmVndWxhclNtYWxsLmNzc307XG4gICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuYnJlYWtwb2ludHMudXAoYHNtYCl9IHtcbiAgICAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLnR5cG9ncmFwaHkucFNtYWxsLmNzc307XG4gIH1cbmBcbiJdfQ== */"));